<div>
	<div class="padding-vertical-25" *ngIf="showTitle"><ngx-skeleton-loader [theme]="{ width: '170px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader></div>
	<div class="item-list">
		<div class="header-item">
			<ngx-skeleton-loader [theme]="{ width: '30%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '5%', 'border-radius': '0', height: '20px', 'background-color': '#FFFFFF' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '20%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '5%', 'border-radius': '0', height: '20px', 'background-color': '#FFFFFF' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '30%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
		</div>
		<div class="padding-vertical-10" *ngFor="let elem of ghostArray">
			<ngx-skeleton-loader [theme]="{ width: '30%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '5%', 'border-radius': '0', height: '20px', 'background-color': '#FFFFFF' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '20%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '5%', 'border-radius': '0', height: '20px', 'background-color': '#FFFFFF' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '30%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
		</div>
	</div>
</div>
